import $ from 'jquery';
import {toCurrency, Cookie, updatePrices, Popup, toCashback} from "../utilities";
import { basketUpdate, basketRecommendations } from "../queries";

$(document).on('change', '.ui-product-quantity', function (e, value) {
    $('.page-basket').trigger('calculate');
    if (+value <= 0) {
        $(this).parents('.page-basket-item').remove();
    }
});

$(document).on('prices-updated', function () {
    $('.page-basket').trigger('calculate');
    $('.page-basket').removeClass('page-basket--loading');
});

$('.page-basket').on('calculate', function () {
    const minPrice = Cookie.get('SUPPRESS_MIN_ORDER_PRICE') === 1 ? 0 : 1000;
    let totalBasePrice = 0;
    let totalPrice = 0;
    let totalPriceLevel2 = 0;
    let totalDiscount = 0;
    let totalQuantity = 0;
    let cashback = 0;
    let totalCashback = 0;

    const itemsDeleted = [];

    $('.page-basket-item').each(function () {
        const $price = $(this).find('.ui-value--product-price');
        const $quantity = $(this).find('.ui-product-quantity');

        if (!$price.attr('data-price')) {
            const name = $(this).find('.page-basket-item__name').text().trim();
            if  (!itemsDeleted.includes(name)) {
                itemsDeleted.push(name);
            }
            $(this).find('.page-basket-item__delete').click();
            $(this).hide();
            return;
        }
        const price = +$price.attr('data-price');
        const priceBase = +$price.attr('data-price-base');
        const priceLevel2 = +$price.attr('data-price-level-2');
        const discount = +$price.attr('data-discount');
        const quantity = +$quantity.attr('data-quantity');
        const cashback = +$price.attr('data-cashback');

        totalBasePrice += priceBase * quantity;
        totalPrice += price * quantity;
        totalCashback += cashback * quantity;
        totalPriceLevel2 += priceLevel2 * quantity;
        totalDiscount += discount * quantity;
        totalQuantity += quantity;

        $(this).find('.page-basket-item__total').text(toCurrency(price * quantity));
        if (cashback){
            $(this).find('.page-basket-item__cashback').text(toCashback(cashback * quantity));
        }

        if (discount > 0) {
            $(this).find('.page-basket-item__discount').text('Скидка ' + toCurrency(discount * quantity)).show();
        } else {
            $(this).find('.page-basket-item__discount').hide();
        }

    });

    if (totalQuantity === 0) {
        $(this).addClass('page-basket--empty');
        return;
    }

    $('.page-basket-restriction').hide();
    $('.page-basket-checkout__proceed').removeClass('ui-button--disabled');
    if (totalPrice < minPrice) {
        $('.page-basket-restriction--1000').trigger('update', {
            percent: 100 * totalPrice / 1000,
            value: 1000 - totalPrice,
        });
        $('.page-basket-checkout__proceed').addClass('ui-button--disabled');
    } else if (totalPrice < 3000) {
        $('.page-basket-restriction--3000').trigger('update', {
            percent: 100 * totalPrice / 3000,
            value: 3000 - totalPrice,
        });
    } else if (window.innerWidth >= 768) {
        $('.page-basket-restriction--success').show();
    }
    if (totalCashback>0){

    }

    const featuredDiscount = totalPrice - totalPriceLevel2;
    if (featuredDiscount > 0) {
        $('.page-basket-feature__title span').first().text(Math.floor(featuredDiscount));
        $('.page-basket-feature').show();
    } else {
        $('.page-basket-feature').hide();
    }

    $('.page-basket-checkout__value--base b').text(toCurrency(totalBasePrice));
    $('.page-basket-checkout__value--discount b').text(toCurrency(totalDiscount));
    if (totalCashback){
        $('.page-basket-checkout__value--cashback b').text(Math.ceil(totalCashback));
    }
    $('.page-basket-checkout__total b').text(toCurrency(totalPrice));
    $('.page-basket-checkout__inner').show();


    if (itemsDeleted.length > 0) {
        const names = itemsDeleted.join(', ');
        setTimeout(() => {
            $('.js-basket-products-not-available-items').text('');
            $('.js-basket-products-not-available-items').text(`Некоторых товаров в вашей корзине нет в наличии, они будут удалены из вашей корзины: ${names}`);
            $(`.ui-modal[data-name="basket-products-not-available"]`).trigger('show');
        }, 10);
    }
});

$('.js-page-basket-checkout__proceed').click(function () {
    if ($(this).hasClass('ui-button--disabled')) {
        return;
    }
    window.location = '/order';
});

$('.page-basket-item__delete').click(async function () {
    const $component = $(this).parents('.page-basket-item');
    const productId = $component.attr('data-product-id');

    $component.remove();
    $('.page-basket').trigger('calculate');

    const response = await basketUpdate(productId, 0);
    $('.header-basket').replaceWith(response.component);
});

$('.page-basket-restriction').on('update', function (e, { percent, value }) {
    $(this).find('.page-basket-restriction__value').text(toCurrency(value));
    if (window.innerWidth >= 768) {
        $(this).show();
    }

    let progress = percent;
    if (progress < 0) {
        progress = 0;
    }
    if (progress > 100) {
        progress = 100;
    }
    const pct = ((100 - progress) / 100) * Math.PI * (33 * 2);
    $(this).find('circle').last().css({ strokeDashoffset: pct });
});

(async function () {
    if ($('.page-basket-recommendations').length === 0) {
        return;
    }

    const response = await basketRecommendations();
    $('.page-basket-recommendations').html(response.component);
    $('.ui-product-slider').trigger('init');
    $('.ui-product').trigger('render');
    updatePrices();
})();

// const cookieKey = 'isBasketMessageShowed1';
// const cookie = Cookie.get(cookieKey);
// if ($('.page-basket').length > 0 && !cookie) {
//     Cookie.set(cookieKey, 1);
//     Popup.notify(`
//         Обращаем ваше внимание, что на период праздничных дней срок обработки заказов увеличивается.
//         Все заказы, оформленные в период с 6 по 10 мая, будут обработаны и переданы в службу доставки 11-го мая.
//         В связи с этим информацию о заказе с трек-номером своего отправления вы получите не ранее 11-го мая.
//         Приносим извинения за доставленные неудобства.<br/><br/>
//         Желаем вам приятных покупок!
// `, 'Уважаемые покупатели!');
// }
